import { AddIcon, Button, Grid, GridRow } from '@bp/ui-components';
import { FieldArray, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import { LessonFormType, LessonFormUnitType } from '../../types';
import { EpochLessonUnitFormItem } from './EpochLessonUnitFormItem';

export const EpochLessonUnitForm = ({ disabled }: { disabled: boolean }) => {
  const { t } = useTranslation();

  const { values, setFieldTouched } = useFormikContext<LessonFormType>();

  return (
    <FieldArray name={'lessonUnit'}>
      {(arrayHelpers) => {
        return (
          <Grid useFormGap>
            {values.lessonUnit?.map((lessonUnit, index) => {
              return (
                <EpochLessonUnitFormItem
                  key={lessonUnit.uuid}
                  index={index}
                  disabled={disabled}
                  onDelete={() => arrayHelpers.remove(index)}
                />
              );
            })}

            <GridRow spacingBottom='none' spacingTop='none'>
              <Button
                key={values.subject?.uuid}
                disabled={disabled}
                hierarchy='tertiary'
                icon={<AddIcon />}
                onClick={async () => {
                  if (values.lessonUnit && values.lessonUnit.length > 0) {
                    for (const index in values.lessonUnit) {
                      await setFieldTouched(`lessonUnit.${index}`);
                    }
                  }
                  const lessonUnit: LessonFormUnitType = {
                    uuid: v4(),
                    count: null,
                    factor: null,
                    duration: null,
                    lessonUnitType: 'subjectHour',
                  };
                  arrayHelpers.push(lessonUnit);
                }}
              >
                {t('subject.addSubjectHour')}
              </Button>
            </GridRow>
          </Grid>
        );
      }}
    </FieldArray>
  );
};
